import React, { useState, useEffect, Fragment } from "react";
import { useSelector, useDispatch } from "react-redux";
import axios from "axios";
import { Tab } from "@headlessui/react";

import { faBed, faCircleUser, faCircleXmark, faPaperclip, faPeopleGroup, faTimes, faTriangleExclamation, faUserGear, faSave, faCamera, faPhone, faUsers, faEnvelope, faTrash, faStar } from "@fortawesome/pro-regular-svg-icons";
import { faWhatsapp } from "@fortawesome/free-brands-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useHistory, useParams } from "react-router-dom";

import { toast } from "react-toastify";
import { openModal } from "../../store/modal/modalReducer";
import NotificationToast from "../Helpers/NotificationToast";
import { Formik, Form, Field } from "formik";
import SubmitButton from "../Forms/SubmitButton";
import CustomButton from "../Helpers/CustomButton";
import { getBooking, getFlaggedIds } from "../../store/booking/bookingActions";
import QuickFormText from "../Forms/QuickFormText";
import QuickFormSelect from "../Forms/QuickFormSelect";
import PhoneInput from "react-phone-number-input";
import SettingsSelect from "../Forms/SettingsSelect";
import SettingsSwitch from "../Forms/SettingsSwitch";
import GridCallHistory from "./GridCallHistory";

function classNames(...classes) {
    return classes.filter(Boolean).join(" ");
}

export default function GridSaveInformation({ setDoc, db, current_staff, setLoading, setIgnoreRefresh }) {
    const dispatch = useDispatch();
    const history = useHistory();
    const [units, setUnits] = useState([]);
    const [unitTypes, setUnitTypes] = useState([]);
    const { current_booking, flagged_ids } = useSelector((state) => state.booking);
    const { permissions } = useSelector((state) => state.auth);
    const canEditApplicantDetails = permissions?.includes('edit_applicant_details') || false;
    const [institutions, SetInstitutions] = useState([]);
    const [campus, setCampus] = useState([]);
    // const { properties } = useSelector((state) => state.properties);
    const { settings } = useSelector((state) => state.settings);
    const [lookups, setLookups] = useState([]);
    const [brokers, setBrokers] = useState([]);
    const [properties, setProperties] = useState([]);
    const [flagLoading, setFlagLoading] = useState(false);
    
    // Contact Details tab state
    const [contacts, setContacts] = useState([]);
    const [contactsLoading, setContactsLoading] = useState(false);
    const [showContactForm, setShowContactForm] = useState(false);
    const [editingContact, setEditingContact] = useState(null);
    const [contactFormData, setContactFormData] = useState({
        name: "",
        number: "",
        email: "",
        whatsapp_enabled: false,
        call_enabled: false,
        email_enabled: false,
        notes: "",
    });

    // Twilio Call state
    const [showCallPanel, setShowCallPanel] = useState(false);
    const [agentCell, setAgentCell] = useState("");
    const [callLoading, setCallLoading] = useState(false);
    const [twilioEnabled, setTwilioEnabled] = useState(false);
    const [availableCallNumbers, setAvailableCallNumbers] = useState([]);
    const [selectedCallNumber, setSelectedCallNumber] = useState(null);

    const { type } = useParams();
    var url_string = window.location.href;
    var url = new URL(url_string);
    var tag_id = url.searchParams.get("tag");

    // console.log("Current booking:", current_booking)

    useEffect(async () => {
        if (process.env.REACT_APP_COLOUR === "UC") {
            getInstitutions();
            getCampus();
        }
        // Check Twilio configuration status
        try {
            const statusResp = await axios.get(`${process.env.REACT_APP_API_URL}twilio/status`);
            setTwilioEnabled(!!statusResp.data?.configured);
        } catch (e) {
            setTwilioEnabled(false);
        }
        if (current_booking.property_id) {
            getUnits(current_booking.property_id);
            getUnitTypes(current_booking.property_id);
        }

        if (settings && settings.brokers === 1) {
            getBrokerList();
        }

        // Load contacts on mount so count shows immediately
        loadContacts();

        axios({
            method: "get",
            url: `${process.env.REACT_APP_API_URL}uc_lookups`,
        })
            .then((response) => {
                setLookups(response.data);
            })
            .catch((error) => {
                // alert("lookups failed");
            });

        axios({
            method: "get",
            url: `${process.env.REACT_APP_API_URL}properties`,
        })
            .then((response) => {
                setProperties(response.data);
            })
            .catch((error) => {
                alert("properties failed");
            });
    }, [setUnits]);

    const openCallPanel = async () => {
        let defaultCell = "";
        if (current_staff && current_staff.cell) {
            defaultCell = current_staff.cell.toString();
            if (defaultCell && defaultCell.charAt(0) !== "+") {
                defaultCell = "+" + defaultCell;
            }
        }
        setAgentCell(defaultCell);
        
        // Load available call numbers
        const numbers = [];
        
        // Add default booking number if it exists
        if (current_booking?.user?.cell && String(current_booking?.user?.cell).trim() !== "" && String(current_booking?.user?.cell).toLowerCase() !== "null") {
            numbers.push({
                number: current_booking.user.cell,
                name: `${current_booking.user.name || ''} ${current_booking.user.surname || ''}`.trim() || 'Primary Contact',
                is_primary: true,
            });
        }
        
        // Load additional contacts with call enabled
        try {
            const response = await axios.get(`${process.env.REACT_APP_API_URL}bookings/${current_booking.id}/contacts`);
            const callContacts = (response.data.contacts || []).filter(c => c.call_enabled && c.number);
            
            callContacts.forEach(contact => {
                numbers.push({
                    number: contact.number,
                    name: contact.name || 'Additional Contact',
                    is_primary: false,
                    contact_id: contact.id,
                });
            });
        } catch (error) {
            console.error("Error loading call contacts:", error);
        }
        
        setAvailableCallNumbers(numbers);
        setSelectedCallNumber(numbers.length > 0 ? numbers[0].number : null);
        setShowCallPanel(true);
    };

    async function initiateCall() {
        if (!agentCell) {
            toast(<NotificationToast title="Agent cell required" message="Please enter your cell number to initiate the call." type="error" />);
            return;
        }
        if (!selectedCallNumber) {
            toast(<NotificationToast title="Number required" message="Please select a number to call." type="error" />);
            return;
        }
        
        setCallLoading(true);
        try {
            const payload = {
                agent_cell: agentCell,
                applicant_cell: selectedCallNumber,
                current_booking,
                current_staff,
            };
            
            const resp = await axios.post(`${process.env.REACT_APP_API_URL}twilio/call`, payload);
            if (resp.data && resp.data.success) {
                const selectedContact = availableCallNumbers.find(n => n.number === selectedCallNumber);
                toast(<NotificationToast title="Calling started" message={`We are calling ${agentCell} and will bridge to ${selectedContact?.name || selectedCallNumber}.`} />);
                setShowCallPanel(false);
            } else {
                toast(<NotificationToast title="Call failed" message={resp.data?.message || "Unable to initiate the call."} type="error" />);
            }
        } catch (e) {
            toast(<NotificationToast title="Call failed" message={e?.response?.data?.message || e?.message || "Unable to initiate the call."} type="error" />);
        } finally {
            setCallLoading(false);
        }
    }

    async function getBrokerList() {
        await axios({
            method: "get",
            url: `${process.env.REACT_APP_API_URL}broker_list`,
        }).then((response) => {
            let list = [];
            list.push({ key: 0, value: 0, label: "None" });
            Object.keys(response.data).forEach((key) => {
                list.push({ key: response.data[key].id, value: response.data[key].id, label: response.data[key].name + " " + response.data[key].surname + " - " + response.data[key].email });
            });
            setBrokers(list);
        });
    }

    async function getUnits(id) {
        await axios({
            method: "get",
            url: `${process.env.REACT_APP_API_URL}units/${id}`,
        }).then((response) => {
            setUnits(response.data);
        });
    }

    async function getInstitutions(id) {
        await axios({
            method: "get",
            url: `${process.env.REACT_APP_API_URL}institutions`,
        }).then((response) => {
            // Ensure all values are numbers for proper comparison
            const institutionsData = response.data.map((item) => ({
                ...item,
                value: Number(item.value),
            }));

            SetInstitutions(institutionsData);
        });
    }

    async function getCampus(id) {
        await axios({
            method: "get",
            url: `${process.env.REACT_APP_API_URL}campus`,
        }).then((response) => {
            // Ensure all values are numbers for proper comparison
            const campusData = response.data.map((item) => ({
                ...item,
                value: Number(item.value),
            }));

            setCampus(campusData);
        });
    }
    async function getUnitTypes(id) {
        await axios({
            method: "get",
            url: `${process.env.REACT_APP_API_URL}unit_types/${id}`,
        }).then((response) => {
            setUnitTypes(response.data);
        });
    }
    async function getUnitTypes(id) {
        await axios({
            method: "get",
            url: `${process.env.REACT_APP_API_URL}unit_types/${id}`,
        }).then((response) => {
            setUnitTypes(response.data);
        });
    }

    //     })
    //         .then((response) => {
    //             dispatch(getBooking(current_booking.id));
    //         })
    //         .catch((error) => {
    //             alert("properties failed");
    //         })
    //         .finally(() => {
    //             setLoading(false);
    //         });
    // }

    async function delinkUnit() {
        await axios({
            method: "post",
            url: `${process.env.REACT_APP_API_URL}delink_user_unit`,
            data: {
                booking_id: current_booking.id,
                user: current_staff,
                move_location: 0,
            },
        })
            .then((response) => {
                dispatch(getBooking(current_booking.id));
            })
            .catch((error) => {
                alert("properties failed");
            })
            .finally(() => {
                setLoading(false);
            });
    }

    // console.log(current_booking)

    async function flagUser(id_number) {
        setFlagLoading(true);
        await axios({
            method: "post",
            url: `${process.env.REACT_APP_API_URL}flag_this_user`,
            data: {
                id_number: id_number,
                booking_id: current_booking.id,
                user_id: current_booking.user.id,
                user: current_staff,
            },
        })
            .then((response) => {
                dispatch(getFlaggedIds());
                dispatch(getBooking(current_booking.id));
            })
            .catch((error) => {
                alert("flagging failed");
            })
            .finally(() => {
                setFlagLoading(false);
            });
    }

    async function unFlagUser(id_number) {
        setFlagLoading(true);
        await axios({
            method: "post",
            url: `${process.env.REACT_APP_API_URL}remove_flaged_user`,
            data: {
                id_number: id_number,
                booking_id: current_booking.id,
                user_id: current_booking.user.id,
                user: current_staff,
            },
        })
            .then((response) => {
                dispatch(getFlaggedIds());
                dispatch(getBooking(current_booking.id));
            })
            .catch((error) => {
                alert("flagging failed");
            })
            .finally(() => {
                setFlagLoading(false);
            });
    }

    // Contact management functions
    const loadContacts = async () => {
        if (!current_booking?.id) return;
        setContactsLoading(true);
        try {
            const response = await axios.get(`${process.env.REACT_APP_API_URL}bookings/${current_booking.id}/contacts`);
            setContacts(response.data.contacts || []);
        } catch (error) {
            console.error("Error loading contacts:", error);
        } finally {
            setContactsLoading(false);
        }
    };

    const resetContactForm = () => {
        setContactFormData({
            name: "",
            number: "",
            email: "",
            whatsapp_enabled: false,
            call_enabled: false,
            email_enabled: false,
            notes: "",
        });
        setEditingContact(null);
        setShowContactForm(false);
    };

    const handleEditContact = (contact) => {
        setContactFormData({
            name: contact.name || "",
            number: contact.number || "",
            email: contact.email || "",
            whatsapp_enabled: contact.whatsapp_enabled || false,
            call_enabled: contact.call_enabled || false,
            email_enabled: contact.email_enabled || false,
            notes: contact.notes || "",
        });
        setEditingContact(contact);
        setShowContactForm(true);
    };

    const handleDeleteContact = async (contactId) => {
        if (!window.confirm("Are you sure you want to delete this contact?")) return;

        try {
            await axios.delete(`${process.env.REACT_APP_API_URL}contacts/${contactId}`);
            toast(<NotificationToast title="Success" message="Contact deleted successfully" />);
            loadContacts();
        } catch (error) {
            console.error("Error deleting contact:", error);
            toast(<NotificationToast title="Error" message="Failed to delete contact" type="error" />);
        }
    };

    const handleSetPrimaryContact = async (contactId) => {
        if (!window.confirm("This will update the user's primary contact number and email. Continue?")) return;

        setContactsLoading(true);
        try {
            await axios.post(`${process.env.REACT_APP_API_URL}contacts/${contactId}/set-primary`);
            toast(<NotificationToast title="Success" message="Contact set as primary successfully" />);
            
            // Reload contacts to show updated primary flags and any auto-saved contacts
            await loadContacts();
            dispatch(getBooking(current_booking.id));
        } catch (error) {
            console.error("Error setting primary contact:", error);
            toast(<NotificationToast title="Error" message="Failed to set primary contact" type="error" />);
        } finally {
            setContactsLoading(false);
        }
    };

    const handleSubmitContact = async (e) => {
        e.preventDefault();

        if (!contactFormData.number && !contactFormData.email) {
            toast(<NotificationToast title="Validation Error" message="At least one contact method (number or email) is required" type="error" />);
            return;
        }

        setContactsLoading(true);
        try {
            if (editingContact) {
                const response = await axios.put(`${process.env.REACT_APP_API_URL}contacts/${editingContact.id}`, contactFormData);
                
                if (response.data.is_duplicate) {
                    toast(<NotificationToast title="Duplicate Found" message="This contact information is already in use" type="error" />);
                    setContactsLoading(false);
                    return;
                }

                toast(<NotificationToast title="Success" message="Contact updated successfully" />);
            } else {
                const response = await axios.post(`${process.env.REACT_APP_API_URL}bookings/${current_booking.id}/contacts`, contactFormData);
                
                if (response.data.is_duplicate) {
                    toast(<NotificationToast title="Duplicate Found" message="This contact information is already in use" type="error" />);
                    setContactsLoading(false);
                    return;
                }

                toast(<NotificationToast title="Success" message="Contact added successfully" />);
            }

            resetContactForm();
            loadContacts();
        } catch (error) {
            console.error("Error saving contact:", error);
            const message = error.response?.data?.message || "Failed to save contact";
            toast(<NotificationToast title="Error" message={message} type="error" />);
        } finally {
            setContactsLoading(false);
        }
    };

    return (
        <Tab.Group>
            <Tab.List className="flex space-x-1 rounded-xl bg-blue-900/20 p-1 mb-4">
                <Tab
                    className={({ selected }) =>
                        classNames(
                            "w-full rounded-lg py-2.5 text-sm font-medium leading-5",
                            "ring-white ring-opacity-60 ring-offset-2 ring-offset-blue-400 focus:outline-none focus:ring-2",
                            selected
                                ? "bg-white shadow text-blue-700"
                                : "text-gray-700 hover:bg-white/[0.12] hover:text-blue-600"
                        )
                    }
                >
                    Applicant Info
                </Tab>
                <Tab
                    onClick={() => loadContacts()}
                    className={({ selected }) =>
                        classNames(
                            "w-full rounded-lg py-2.5 text-sm font-medium leading-5",
                            "ring-white ring-opacity-60 ring-offset-2 ring-offset-blue-400 focus:outline-none focus:ring-2",
                            selected
                                ? "bg-white shadow text-blue-700"
                                : "text-gray-700 hover:bg-white/[0.12] hover:text-blue-600"
                        )
                    }
                >
                    Contact Details {contacts.length > 0 && `(${contacts.length})`}
                </Tab>
            </Tab.List>
            <Tab.Panels>
                <Tab.Panel>
                    <div className="h-96 overflow-y-scroll scroll-smooth">
                        {/* Start Information */}
                        <Formik
                enableReinitialize
                initialValues={{
                    name: current_booking.user.name,
                    surname: current_booking.user.surname,
                    company_name: current_booking?.user?.profile?.company_name ?? "",
                    email: current_booking.user.email,
                    cell: "+" + current_booking.user.cell,
                    joint_application: current_booking.joint_application,
                    company_application: current_booking.company_application,
                    booking_reference: current_booking.booking_reference,
                    id_number: current_booking?.user?.profile?.id_number ?? "",
                    area: current_booking?.area ?? "",
                    gender: current_booking?.user?.profile?.gender ?? "",
                    broker_id: current_booking.user.broker_id ?? 0,
                    message_broker: current_booking.user.message_broker ?? "",

                    study_year_id: current_booking.study_year_id ?? 0,
                    student_number: current_booking?.user?.profile?.student_number ?? "",
                    property_id: current_booking.property_id ?? 0,
                    unit_type: current_booking?.unit_type?.id ?? 0,

                    institution_study_id: Number(current_booking.institution_study_id ?? 0),
                    institution_study_other: current_booking.institution_study_other ?? "",
                    institution_campus_id: Number(current_booking.institution_campus_id ?? 0),
                    student_type: current_booking.student_type ?? 0,
                    budget_id: current_booking.budget_id ?? 0,
                    lead_source_id: current_booking.lead_source_id ?? 0,
                    interested_unit: current_booking.interested_unit ?? "",
                    duration: current_booking.duration ?? 0,
                    location_id: current_booking.location_id ?? 0,
                }}
                onSubmit={async (values, { setSubmitting, setErrors, resetForm }) => {
                    //format cell
                    values.cell = values.cell.replace("+", "");

                    let submitData = {
                        name: values.name,
                        surname: values.surname,
                        company_name: values.company_name,
                        email: values.email,
                        cell: values.cell,
                        booking: current_booking.id,
                        joint_application: values.joint_application,
                        company_application: values.company_application,
                        booking_reference: values.booking_reference,
                        id_number: values.id_number,
                        area: values.area,
                        gender: values.gender,

                        institution_study_id: values.institution_study_id,
                        institution_study_other: values.institution_study_other,
                        institution_campus_id: values.institution_campus_id,
                        student_type: values.student_type,

                        study_year_id: values.study_year_id,
                        student_number: values.student_number,
                        property_id: values.property_id,
                        unit_type: values.unit_type,
                        budget_id: values.budget_id,
                        lead_source_id: values.lead_source_id,

                        type: type,
                        tag_id: tag_id,
                        current_staff_id: current_staff.id,
                        interested_unit: values.interested_unit,
                        duration: values.duration,
                        location_id: values.location_id,
                    };

                    if (settings && settings.brokers === 1 && current_booking.user.is_broker === 0) {
                        submitData.broker_id = values.broker_id;
                        submitData.message_broker = values.message_broker;
                    }

                    await axios({
                        method: "post",
                        url: `${process.env.REACT_APP_API_URL}quick_save/${current_booking.user.id}`,
                        data: submitData,
                    })
                        .then((resp) => {
                            if (resp.data != "success") {
                                toast(<NotificationToast title="Something went wrong" message={resp.data} type="error" />);
                            } else {
                                // setDoc(
                                //     doc(db, "Bookings", String(current_booking.id)),
                                //     {
                                //         name: values.name,
                                //         surname: values.surname,
                                //         email: values.email,
                                //         cell: values.cell,
                                //         joint_application: parseInt(values.joint_application),
                                //         company_application: parseInt(values.company_application),
                                //         booking_reference: values.booking_reference,
                                //         id_number: values.id_number,
                                //         gender: values.gender
                                //     },
                                //     { merge: true }
                                // );

                                setIgnoreRefresh(true);
                                dispatch(getBooking(current_booking.id));
                                // setIgnoreRefresh(false);
                                toast(<NotificationToast title="Success" message="Data has been updated sucessfully" />);
                            }

                            // Add the + back for form prettiness
                            values.cell = "+" + values.cell;
                        })
                        .catch((error) => {
                            console.log(error);
                            toast(<NotificationToast title="Something went wrong" message="" type="error" />);
                        });

                    setSubmitting(false);
                }}
            >
                {({ values, touched, errors, setFieldValue, setFieldTouched, handleSubmit, isValid, isSubmitting, dirty }) => (
                    <Form onSubmit={handleSubmit} className="rounded-3xl">
                        {settings && settings.brokers === 1 && current_booking?.user?.is_broker === 1 ? (
                            <>
                                <p className="text-center text-xl">Broker Account</p>
                                <br />
                            </>
                        ) : (
                            ""
                        )}
                        {process.env.REACT_APP_COLOUR === "UC" ? (
                            <>
                                <div className="pb-6 grid gap-x-2 gap-y-8 grid-cols-2">
                                    <Field label={"Name"} name="name" as={QuickFormText} />
                                    <Field label={"Surname"} name="surname" as={QuickFormText} />
                                    {/* <Field label={"Cell"} name="cell" as={QuickFormText} prepend="+" /> */}
                                </div>
                                <div className="pb-6 grid gap-x-2 gap-y-8 grid-cols-1">
                                    <div>
                                        <label htmlFor="cell" className="text-sm text-dark_background">
                                            <span>Cell</span>
                                        </label>
                                        <div>
                                            <PhoneInput
                                                defaultCountry="ZA"
                                                international
                                                countryCallingCodeEditable={false}
                                                onChange={(val) => {
                                                    setFieldValue("cell", val);
                                                }}
                                                onBlur={setFieldTouched}
                                                name="cell"
                                                value={values.cell}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="pb-6 grid gap-x-2 gap-y-8 grid-cols-2">
                                    <Field label={"Email Address"} name="email" as={QuickFormText} />
                                    <Field label={"Reference"} name="booking_reference" as={QuickFormText} disabled={true} />
                                    <Field label={"ID Number"} name="id_number" as={QuickFormText} />

                                    {process.env.REACT_APP_COLOUR === "UC" && (
                                        <div>
                                            <QuickFormSelect
                                                label="Gender"
                                                name="gender"
                                                onChange={setFieldValue}
                                                onBlur={setFieldTouched}
                                                value={values.gender}
                                                touched={touched.gender}
                                                error={errors.gender}
                                                options={"gender"}
                                            />
                                            {current_booking.bed_id > 0 && current_booking.unit?.floor?.gender != values.gender && (
                                                <h2 className="text-red-700 font-bold">Please note there is a difference between the chosen bed, and the gender of this user.</h2>
                                            )}
                                        </div>
                                    )}

                                    {process.env.REACT_APP_COLOUR === "UC" && (
                                        <QuickFormSelect
                                            label="Funding Type"
                                            name="student_type"
                                            onChange={setFieldValue}
                                            onBlur={setFieldTouched}
                                            value={values.student_type}
                                            touched={touched.student_type}
                                            error={errors.student_type}
                                            options={"student_types"}
                                            disabled={!canEditApplicantDetails}
                                        />
                                    )}

                                    {process.env.REACT_APP_COLOUR === "UC" && (values.student_type == 1 || values.student_type == 6) && (
                                        <QuickFormSelect
                                            label="Duration"
                                            name="duration"
                                            onChange={setFieldValue}
                                            onBlur={setFieldTouched}
                                            value={values.duration}
                                            touched={touched.duration}
                                            error={errors.duration}
                                            options={"duration"}
                                            disabled={!canEditApplicantDetails}
                                        />
                                    )}

                                    {process.env.REACT_APP_COLOUR === "UC" && (
                                        <>
                                            <QuickFormSelect
                                                label="Institution"
                                                name="institution_study_id"
                                                onChange={(e) => {
                                                    setFieldValue("institution_study_id", e.target.value);
                                                    // Reset the other field when changing institutions
                                                    if (e.target.value !== "other") {
                                                        setFieldValue("institution_study_other", "");
                                                    }
                                                }}
                                                onBlur={setFieldTouched}
                                                value={values.institution_study_id}
                                                touched={touched.institution_study_id}
                                                error={errors.institution_study_id}
                                                options={[...institutions, { value: 99999, label: "Other" }]}
                                                disabled={!canEditApplicantDetails}
                                            />

                                            {values.institution_study_id === 99999 && <Field label={"Institution Name"} name="institution_study_other" as={QuickFormText} />}

                                            <QuickFormSelect
                                                label="Campus"
                                                name="institution_campus_id"
                                                onChange={setFieldValue}
                                                onBlur={setFieldTouched}
                                                value={values.institution_campus_id}
                                                touched={touched.institution_campus_id}
                                                error={errors.institution_campus_id}
                                                options={campus}
                                                disabled={!canEditApplicantDetails}
                                            />
                                        </>
                                    )}

                                    {process.env.REACT_APP_COLOUR !== "UC" && (
                                        <div>
                                            <QuickFormSelect
                                                label="Joint Application"
                                                name="joint_application"
                                                onChange={setFieldValue}
                                                onBlur={setFieldTouched}
                                                value={values.joint_application}
                                                touched={touched.joint_application}
                                                error={errors.joint_application}
                                                options={"yesNo"}
                                            />
                                            <QuickFormSelect
                                                label="Company Application"
                                                name="company_application"
                                                onChange={setFieldValue}
                                                onBlur={setFieldTouched}
                                                value={values.company_application}
                                                touched={touched.company_application}
                                                error={errors.company_application}
                                                options={"yesNo"}
                                            />
                                        </div>
                                    )}

                                    <div>
                                        <SettingsSelect
                                            label="Study Year"
                                            name="study_year_id"
                                            onChange={setFieldValue}
                                            onBlur={setFieldTouched}
                                            value={values.study_year_id}
                                            touched={touched.study_year_id}
                                            error={errors.study_year_id}
                                            options={lookups ? lookups[8] : null}
                                            disabled={!canEditApplicantDetails}
                                        />
                                    </div>

                                    {process.env.REACT_APP_COLOUR === "UC" && (
                                        <div>
                                            <Field label={"Student Number"} name="student_number" as={QuickFormText} />
                                        </div>
                                    )}

                                    <div>
                                        <SettingsSelect
                                            label="Unit Type"
                                            name="unit_type"
                                            onChange={setFieldValue}
                                            value={values.unit_type}
                                            options={unitTypes.length > 0 ? unitTypes : "none"}
                                            disabled={!canEditApplicantDetails}
                                        />
                                    </div>

                                    <div>
                                        <SettingsSelect
                                            label="Budget"
                                            name="budget_id"
                                            onChange={setFieldValue}
                                            value={values.budget_id}
                                            options={lookups?.[15] ?? "none"}
                                            disabled={!canEditApplicantDetails}
                                        />
                                    </div>

                                    <div>
                                        <SettingsSelect
                                            label="Lead Source"
                                            name="lead_source_id"
                                            onChange={setFieldValue}
                                            value={values.lead_source_id}
                                            options={lookups?.[13] ?? "none"}
                                            disabled={!canEditApplicantDetails}
                                        />
                                    </div>

                                    <div>
                                        <SettingsSelect
                                            label="Property"
                                            name="property_id"
                                            getUnitTypes={getUnitTypes}
                                            onChange={setFieldValue}
                                            value={values.property_id}
                                            options={properties}
                                            disabled={!canEditApplicantDetails}
                                        />
                                    </div>
                                    {process.env.REACT_APP_COLOUR === "UC" && (
                                        <div>
                                            <SettingsSelect
                                                label="Location"
                                                name="location_id"
                                                onChange={setFieldValue}
                                                value={values.location_id}
                                                options={lookups?.[16] ?? "none"}
                                                disabled={!canEditApplicantDetails}
                                            />
                                        </div>
                                    )}
                                </div>
                            </>
                        ) : (
                            <>
                                <div className="pb-6 grid gap-x-2 gap-y-8 grid-cols-2">
                                    <Field label={"Name"} name="name" as={QuickFormText} />
                                    <Field label={"Surname"} name="surname" as={QuickFormText} />
                                    {/* <Field label={"Cell"} name="cell" as={QuickFormText} prepend="+" /> */}
                                </div>

                                {process.env.REACT_APP_COLOUR === "QP" && (
                                    <div className="pb-6">
                                        <Field label={"Company Name"} name="company_name" as={QuickFormText} />
                                    </div>
                                )}

                                <div className="pb-6 grid gap-x-2 gap-y-8 grid-cols-1">
                                    <div>
                                        <label htmlFor="cell" className="text-sm text-dark_background">
                                            <span>Cell</span>
                                        </label>
                                        <div>
                                            <PhoneInput
                                                defaultCountry="ZA"
                                                international
                                                countryCallingCodeEditable={false}
                                                onChange={(val) => {
                                                    setFieldValue("cell", val);
                                                }}
                                                onBlur={setFieldTouched}
                                                name="cell"
                                                value={values.cell != "+null" ? values.cell : "+27"}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="pb-6 grid gap-x-2 gap-y-8 grid-cols-2">
                                    <Field label={"Email Address"} name="email" as={QuickFormText} />
                                    <Field label={"Reference"} name="booking_reference" as={QuickFormText} disabled={true} />
                                    {process.env.REACT_APP_COLOUR === "QL" ? (
                                        <>
                                            <QuickFormSelect
                                                label="Joint Application"
                                                name="joint_application"
                                                onChange={setFieldValue}
                                                onBlur={setFieldTouched}
                                                value={values.joint_application}
                                                touched={touched.joint_application}
                                                error={errors.joint_application}
                                                options={"yesNo"}
                                            />
                                            <QuickFormSelect
                                                label="Company Application"
                                                name="company_application"
                                                onChange={setFieldValue}
                                                onBlur={setFieldTouched}
                                                value={values.company_application}
                                                touched={touched.company_application}
                                                error={errors.company_application}
                                                options={"yesNo"}
                                            />
                                        </>
                                    ) : (
                                        ""
                                    )}
                                    <Field label={"ID Number"} name="id_number" as={QuickFormText} />
                                    {process.env.REACT_APP_COLOUR === "QL" && (
                                        <Field label={"Area"} name="area" as={QuickFormText} />
                                    )}

                                    {process.env.REACT_APP_HIDE_CHAT_TABS && process.env.REACT_APP_HIDE_CHAT_TABS === "true" && (
                                        <Field label={"Unit Number"} name="interested_unit" as={QuickFormText} />
                                    )}
                                </div>
                            </>
                        )}

                        {settings && settings.brokers === 1 && current_booking?.user?.is_broker === 0 ? (
                            <>
                                <SettingsSelect
                                    label="Broker"
                                    name="broker_id"
                                    onChange={setFieldValue}
                                    onBlur={setFieldTouched}
                                    value={values.broker_id}
                                    touched={touched.broker_id}
                                    error={errors.broker_id}
                                    options={brokers}
                                />
                                <br />
                                <Field name="message_broker" as={SettingsSwitch} label="Message Broker" />
                                <br />
                            </>
                        ) : (
                            ""
                        )}

                        {!current_staff.building_manager && current_staff?.hideAppInfoUpdate != 1 ? (
                            <SubmitButton name="Save" disabled={!isValid || isSubmitting || !dirty} isSubmitting={isSubmitting} icon={faSave} text="Update" style={{ width: "100%" }} />
                        ) : (
                            ""
                        )}
                    </Form>
                )}
            </Formik>
            <div className="border-t-2 border-white mt-2 py-2 w-auto">
                {!current_staff.building_manager ? (
                    <>
                        {settings && settings.brokers === 1 && current_booking?.user?.is_broker === 1 ? (
                            <>
                                <CustomButton
                                    text="Broker Applicants"
                                    styling="w-full mb-2"
                                    icon={faPeopleGroup}
                                    onClick={() =>
                                        dispatch(
                                            openModal({
                                                modal_type: "ModalBrokerApplicants",
                                                modal_props: {
                                                    current_booking: current_booking,
                                                },
                                            })
                                        )
                                    }
                                />
                            </>
                        ) : (
                            ""
                        )}

                        {current_staff?.hideAppInfoUpdate != 1 && (
                            <CustomButton
                                text="Merged Applicants"
                                styling="w-full mb-2"
                                icon={faUserGear}
                                onClick={() =>
                                    dispatch(
                                        openModal({
                                            modal_type: "ModalMergedApplicants",
                                            modal_props: {
                                                current_booking: current_booking,
                                            },
                                        })
                                    )
                                }
                            />
                        )}

                        <CustomButton
                            text="Attachments | View All"
                            styling="w-full"
                            icon={faPaperclip}
                            onClick={() =>
                                dispatch(
                                    openModal({
                                        modal_type: "SlideoverFiles",
                                        modal_props: { type: type, tag_id: tag_id, current_booking: current_booking },
                                    })
                                )
                            }
                        />

                        {current_staff?.hideAppInfoUpdate != 1 && (
                            <CustomButton text="View Applicant" styling="w-full mt-2" icon={faCircleUser} onClick={() => history.push("/edit/" + current_booking.user.id + "/" + current_booking.id)} />
                        )}
                    </>
                ) : (
                    ""
                )}

                {process.env.REACT_APP_COLOUR === "QL" && (
                    <>
                        <div className="text-center mt-4">
                            <p>{current_booking?.property?.name}</p>
                            <p>
                                {current_booking?.waiting_unit_id > 0 ? current_booking?.waiting_unit?.name : current_booking?.unit?.name}{" "}
                                {current_booking?.waiting_unit_id > 0 ? " or similar. (on waitlist)" : ""}
                            </p>
                        </div>
                        {!current_staff.building_manager ? (
                            <CustomButton
                                text="Link Unit"
                                styling="w-full mt-2"
                                icon={faBed}
                                onClick={() =>
                                    dispatch(
                                        openModal({
                                            modal_type: "ModalUnitAssignment",
                                            modal_props: {
                                                current_booking,
                                                type: type,
                                                tag_id: tag_id,
                                            },
                                        })
                                    )
                                }
                            />
                        ) : (
                            ""
                        )}

                        {(current_booking.waiting_unit_id > 0 || current_booking.unit_id > 0) && !current_staff.building_manager ? (
                            <CustomButton text="De-link Unit" styling="w-full mt-2" icon={faBed} onClick={() => delinkUnit()} />
                        ) : (
                            ""
                        )}
                    </>
                )}

                {/* changed to uc1 to hide for now */}
                {process.env.REACT_APP_COLOUR === "UC1" && (
                    <>
                        <div className="text-center mt-4">
                            <p>{current_booking?.property?.name}</p>
                            <p>
                                {/* {current_booking?.unit?.name} {current_booking?.bed?.name} */}
                                {current_booking?.unit?.name} {current_booking?.waiting_bed_id > 0 ? current_booking?.waiting_bed?.name : current_booking?.bed?.name}{" "}
                                {current_booking?.waiting_bed_id > 0 ? " or similar. (on waitlist)" : ""}
                            </p>
                            <p>
                                {current_booking?.unit_type?.name}
                                {current_booking?.rates?.[current_booking.rates.length - 1]?.signed_lease_at && !current_booking?.bed?.name && " Queue"}
                            </p>
                        </div>

                        {/* {console.log(current_booking?.rates[current_booking.rates.length - 1].signed_lease_at != "")} */}

                        {/* current_booking?.rates[current_booking.rates.length - 1].signed_lease_at == "" */}

                        {/* {current_booking.bed_id > 0 && !current_staff.building_manager ? ( */}
                        {/* {(current_staff.isSuper == 1 || current_staff.email == "rowan@qholdings.co.za") &&
                        (current_booking.waiting_bed_id > 0 || current_booking.bed_id > 0) &&
                        !current_staff.building_manager ? (
                            <CustomButton text="De-link Bed" styling="w-full mt-2" icon={faBed} onClick={() => delinkBed()} />
                        ) : (
                            ""
                        )} */}
                    </>
                )}

                {current_staff?.hideAppInfoUpdate != 1 && (
                    <>
                        {flagged_ids.length > 0 && flagged_ids.includes(current_booking?.user?.profile?.id_number) ? (
                            <>
                                <CustomButton
                                    text="Remove Flag From User"
                                    styling="w-full mt-2"
                                    icon={faCircleXmark}
                                    onClick={() => unFlagUser(current_booking.user?.profile?.id_number)}
                                    loading={flagLoading}
                                    disabled={flagLoading}
                                />
                            </>
                        ) : (
                            <>
                                <CustomButton
                                    text="Flag User"
                                    styling="w-full mt-2"
                                    icon={faTriangleExclamation}
                                    onClick={() => flagUser(current_booking.user?.profile?.id_number)}
                                    loading={flagLoading}
                                    disabled={flagLoading}
                                />
                            </>
                        )}
                    </>
                )}

                {/* Call button placed below Flag User */}
                {twilioEnabled && current_booking?.user?.cell && String(current_booking?.user?.cell).trim() !== "" && String(current_booking?.user?.cell).toLowerCase() !== "null" && (
                    <div className="mt-3">
                        <CustomButton text="Call" styling="w-full" icon={faPhone} onClick={openCallPanel} />

                        {/* Modal Overlay */}
                        {showCallPanel && (
                            <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 overflow-y-auto">
                                <div className="bg-white w-full max-w-2xl rounded-2xl shadow-xl p-6 mx-4 my-8 max-h-[90vh] overflow-y-auto">
                                    <h3 className="text-lg font-medium text-gray-900 mb-2">Initiate Call</h3>
                                    <p className="text-sm text-gray-600 mb-4">Enter your mobile number. We will call you first and then connect you to the selected contact.</p>
                                    
                                    <div className="mb-4">
                                        <label htmlFor="agent-cell" className="block text-sm font-medium mb-2 text-gray-700">
                                            Your Cell
                                        </label>
                                        <PhoneInput id="agent-cell" defaultCountry="ZA" value={agentCell} onChange={setAgentCell} placeholder="Enter your cell number" />
                                    </div>

                                    {availableCallNumbers.length > 1 && (
                                        <div className="mb-4">
                                            <label htmlFor="contact-select" className="block text-sm font-medium mb-2 text-gray-700">
                                                Select Number to Call
                                            </label>
                                            <select
                                                id="contact-select"
                                                value={selectedCallNumber || ''}
                                                onChange={(e) => setSelectedCallNumber(e.target.value)}
                                                className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
                                            >
                                                {availableCallNumbers.map((contact, idx) => (
                                                    <option key={idx} value={contact.number}>
                                                        {contact.name} - {contact.number} {contact.is_primary ? '(Primary)' : ''}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>
                                    )}

                                    {availableCallNumbers.length === 1 && (
                                        <div className="mb-4 p-3 bg-gray-50 rounded-lg">
                                            <p className="text-sm text-gray-600">
                                                <strong>Calling:</strong> {availableCallNumbers[0].name}
                                            </p>
                                            <p className="text-sm text-gray-500">{availableCallNumbers[0].number}</p>
                                        </div>
                                    )}

                                    <div className="flex items-center justify-end gap-2 mb-6">
                                        <button type="button" className="px-4 py-2 rounded-lg bg-gray-200 hover:bg-gray-300" onClick={() => setShowCallPanel(false)}>
                                            Cancel
                                        </button>
                                        <button
                                            type="button"
                                            onClick={initiateCall}
                                            disabled={callLoading}
                                            className="px-4 py-2 rounded-lg bg-primary text-white hover:bg-primary_hover disabled:opacity-60"
                                        >
                                            {callLoading ? "Calling..." : "Call"}
                                        </button>
                                    </div>

                                    {/* Call History Section */}
                                    <div className="border-t pt-6">
                                        <GridCallHistory current_booking={current_booking} />
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                )}

                {/* Old Delete User button removed */}
                        </div>
                    </div>
                </Tab.Panel>

                <Tab.Panel>
                    <div className="h-96 overflow-y-auto overflow-x-visible p-4">
                        {!showContactForm ? (
                            <>
                                <div className="mb-4">
                                    <button
                                        onClick={() => setShowContactForm(true)}
                                        className="w-full inline-flex justify-center items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-blue-600 hover:bg-blue-700"
                                    >
                                        <FontAwesomeIcon icon={faUsers} className="mr-2" />
                                        Add Contact
                                    </button>
                                </div>

                                {contactsLoading ? (
                                    <div className="text-center py-8">Loading contacts...</div>
                                ) : contacts.length === 0 ? (
                                    <div className="text-center py-8 text-gray-500">
                                        No additional contacts yet. Click "Add Contact" to get started.
                                    </div>
                                ) : (
                                    <div className="space-y-4 overflow-x-visible">
                                        {contacts.map((contact) => (
                                            <div key={contact.id} className="border rounded-lg p-4 bg-white shadow-sm">
                                                <div className="flex items-center gap-2 mb-2">
                                                    <h4 className="font-semibold text-gray-900">
                                                        {contact.name || "Unnamed Contact"}
                                                    </h4>
                                                    {contact.is_primary && (
                                                        <span className="inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-yellow-100 text-yellow-800">
                                                            <FontAwesomeIcon icon={faStar} className="mr-1" />
                                                            Primary
                                                        </span>
                                                    )}
                                                </div>
                                                
                                                <div className="space-y-1 text-sm text-gray-600 mb-2">
                                                    {contact.number && (
                                                        <div className="flex items-center gap-2">
                                                            <FontAwesomeIcon icon={faPhone} className="w-4" />
                                                            <span>{contact.number}</span>
                                                        </div>
                                                    )}
                                                    {contact.email && (
                                                        <div className="flex items-center gap-2">
                                                            <FontAwesomeIcon icon={faEnvelope} className="w-4" />
                                                            <span>{contact.email}</span>
                                                        </div>
                                                    )}
                                                </div>

                                                <div className="flex gap-2 mb-3">
                                                    {contact.whatsapp_enabled && (
                                                        <span className="inline-flex items-center px-2 py-1 rounded text-xs font-medium bg-green-100 text-green-800">
                                                            <FontAwesomeIcon icon={faWhatsapp} className="mr-1" />
                                                            WhatsApp
                                                        </span>
                                                    )}
                                                    {contact.call_enabled && (
                                                        <span className="inline-flex items-center px-2 py-1 rounded text-xs font-medium bg-blue-100 text-blue-800">
                                                            <FontAwesomeIcon icon={faPhone} className="mr-1" />
                                                            Call
                                                        </span>
                                                    )}
                                                    {contact.email_enabled && (
                                                        <span className="inline-flex items-center px-2 py-1 rounded text-xs font-medium bg-purple-100 text-purple-800">
                                                            <FontAwesomeIcon icon={faEnvelope} className="mr-1" />
                                                            Email
                                                        </span>
                                                    )}
                                                </div>

                                                {contact.notes && (
                                                    <div className="mb-3 text-sm text-gray-500 italic">
                                                        {contact.notes}
                                                    </div>
                                                )}

                                                <div className="flex items-center justify-between pt-3 border-t border-gray-200">
                                                    <div className="flex items-center gap-3">
                                                        {!contact.is_primary && (
                                                            <button
                                                                onClick={() => handleSetPrimaryContact(contact.id)}
                                                                className="text-yellow-500 hover:text-yellow-600 transition-colors"
                                                                title="Set as Primary"
                                                            >
                                                                <FontAwesomeIcon icon={faStar} className="text-lg" />
                                                            </button>
                                                        )}
                                                        <button
                                                            onClick={() => handleEditContact(contact)}
                                                            className="text-blue-600 hover:text-blue-700 text-sm transition-colors"
                                                        >
                                                            Edit
                                                        </button>
                                                        <button
                                                            onClick={() => handleDeleteContact(contact.id)}
                                                            className="text-red-600 hover:text-red-700 transition-colors"
                                                            title="Delete Contact"
                                                        >
                                                            <FontAwesomeIcon icon={faTrash} />
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                )}
                            </>
                        ) : (
                            <form onSubmit={handleSubmitContact} className="space-y-4">
                                <div>
                                    <label className="block text-sm font-medium text-gray-700">Name (Optional)</label>
                                    <input
                                        type="text"
                                        value={contactFormData.name}
                                        onChange={(e) => setContactFormData({ ...contactFormData, name: e.target.value })}
                                        className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-blue-500 focus:border-blue-500"
                                        placeholder="e.g., Parent, Guarantor"
                                    />
                                </div>

                                <div>
                                    <label className="block text-sm font-medium text-gray-700">Phone Number</label>
                                    <input
                                        type="text"
                                        value={contactFormData.number}
                                        onChange={(e) => setContactFormData({ ...contactFormData, number: e.target.value })}
                                        className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-blue-500 focus:border-blue-500"
                                        placeholder="+27..."
                                    />
                                </div>

                                <div>
                                    <label className="block text-sm font-medium text-gray-700">Email</label>
                                    <input
                                        type="email"
                                        value={contactFormData.email}
                                        onChange={(e) => setContactFormData({ ...contactFormData, email: e.target.value })}
                                        className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-blue-500 focus:border-blue-500"
                                        placeholder="email@example.com"
                                    />
                                </div>

                                <div>
                                    <label className="block text-sm font-medium text-gray-700 mb-2">Communication Channels</label>
                                    <div className="space-y-2">
                                        <label className="flex items-center">
                                            <input
                                                type="checkbox"
                                                checked={contactFormData.whatsapp_enabled}
                                                onChange={(e) => setContactFormData({ ...contactFormData, whatsapp_enabled: e.target.checked })}
                                                className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
                                            />
                                            <span className="ml-2 text-sm text-gray-700">
                                                <FontAwesomeIcon icon={faWhatsapp} className="mr-1 text-green-600" />
                                                WhatsApp
                                            </span>
                                        </label>
                                        <label className="flex items-center">
                                            <input
                                                type="checkbox"
                                                checked={contactFormData.call_enabled}
                                                onChange={(e) => setContactFormData({ ...contactFormData, call_enabled: e.target.checked })}
                                                className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
                                            />
                                            <span className="ml-2 text-sm text-gray-700">
                                                <FontAwesomeIcon icon={faPhone} className="mr-1 text-blue-600" />
                                                Call
                                            </span>
                                        </label>
                                        <label className="flex items-center">
                                            <input
                                                type="checkbox"
                                                checked={contactFormData.email_enabled}
                                                onChange={(e) => setContactFormData({ ...contactFormData, email_enabled: e.target.checked })}
                                                className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
                                            />
                                            <span className="ml-2 text-sm text-gray-700">
                                                <FontAwesomeIcon icon={faEnvelope} className="mr-1 text-purple-600" />
                                                Email
                                            </span>
                                        </label>
                                    </div>
                                </div>

                                <div>
                                    <label className="block text-sm font-medium text-gray-700">Notes (Optional)</label>
                                    <textarea
                                        value={contactFormData.notes}
                                        onChange={(e) => setContactFormData({ ...contactFormData, notes: e.target.value })}
                                        rows={3}
                                        className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-blue-500 focus:border-blue-500"
                                        placeholder="Additional information about this contact"
                                    />
                                </div>

                                <div className="flex gap-2 justify-end pt-4">
                                    <button
                                        type="button"
                                        onClick={resetContactForm}
                                        className="px-4 py-2 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 bg-white hover:bg-gray-50"
                                    >
                                        Cancel
                                    </button>
                                    <button
                                        type="submit"
                                        disabled={contactsLoading}
                                        className="px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-blue-600 hover:bg-blue-700 disabled:opacity-50"
                                    >
                                        {contactsLoading ? "Saving..." : editingContact ? "Update Contact" : "Add Contact"}
                                    </button>
                                </div>
                            </form>
                        )}
                    </div>
                </Tab.Panel>
            </Tab.Panels>
        </Tab.Group>
    );
}
